import { useEffect, useRef } from "react";

export const Cursor = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    const move = (e) => {
      el.style.left = e.clientX + "px";
      el.style.top = e.clientY + "px";
      const cta = e.target.closest("button, a, .cta");
      el.classList.toggle("on-cta", !!cta);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, []);
  return <div ref={ref} className="custom-cursor" />;
};
